import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBackward: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"backward, delete, remove, key"} maskId="square-filled-radius-0-stroke-1-IconBackward"><path fillRule="evenodd" clipRule="evenodd" d="M21.9972 4H5.71406L0.914062 12L5.71406 20H21.9972V4ZM10.498 8.79289L9.79094 9.5L12.2909 12L9.79094 14.5L10.498 15.2071L12.998 12.7071L15.498 15.2071L16.2052 14.5L13.7052 12L16.2052 9.5L15.498 8.79289L12.998 11.2929L10.498 8.79289Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBackward;
